import SendAnonymousCvModal from '../../components/SendAnonymousCvModal';
import './CandidateModal.css';
import CvDeliveryHistory from '../../components/CvDeliveryHistory';
import CandidateEvaluation from "../../components/CandidateEvaluation";
import PressentiClients from "./PressentiClients";
import RqthBadge from "../../components/RqthBadge";
import CandidateHistory from "./CandidateHistory";
import CandidatePhoto from "./CandidatePhoto";
import { formatPhone } from "../../utils/formatPhone";
import { candidateName } from "../../utils/candidateName";
import CandidateProfileEditor from "./CandidateProfileEditor";
import { message } from "antd";
import AbsencesPage from "./AbsencesPage";
import AcomptesPage from "./AcomptesPage";
import { createAcompte } from "../../services/acompteApi";
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, User, Mail, Phone, Calendar, Briefcase, FileText, MessageSquare, Clock, DollarSign, CheckCircle2, XCircle, AlertCircle, Target, Activity } from "lucide-react";
import { AddDocumentModal } from "../../components/reusableComponents/AddDocumentModal";
import { AddInterviewModal } from "../../components/reusableComponents/AddInterviewModal";
import { AddCommentModal } from "../../components/reusableComponents/AddCommentModal";
import { AddOpportunityModal } from "../../components/reusableComponents/AddOpportunityModal";
import { AddContractModal } from "../../components/reusableComponents/AddContractModal";
import { AddPayslipModal } from "../../components/reusableComponents/AddPayslipModal";
import { ActivateCandidateModal } from "../../components/reusableComponents/ActivateCandidateModal";
import { AdvancePaymentModal } from "../../components/reusableComponents/AdvancePaymentModal";
import { ReferenceCheckModal } from "../../components/reusableComponents/ReferenceCheckModal";
import { SendToFreelanceModal } from "../../components/reusableComponents/SendToFreelanceModal";
import { SickLeaveModal } from "../../components/reusableComponents/SickLeaveModal";
import { AddAtdModal } from "../../components/reusableComponents/AddAtdModal";
import { PlacementContractModal } from "../../components/reusableComponents/PlacementContractModal";
import { EditProfileModal } from "../../components/reusableComponents/EditProfileModal";
import { AddRatingModal } from "../../components/reusableComponents/AddratingModal";
import DocumentSection from "./DocumentSection";
import "react-toastify/dist/ReactToastify.css";
import AvailableTable from "./AvailableTable";

import CandidatContract from "./CandidateContract";
import InterviewsSection from "./InterviewsSection";
import OpportunitiesSection from "./OpportunitiesSection";
export const CandidateModal = ({
  isOpen,
  onClose,
  candidate: initialCandidate,
  candidates,
  setCandidates,
  initialTab = "profile",
}) => {
  const [sendCvOpen,setSendCvOpen] = useState(false);
  const [cvHistoryVersion,setCvHistoryVersion] = useState(0);
  // Tabs state
  const [activeTab, setActiveTab] = useState(initialTab === "comments" ? "history" : initialTab);
  const [candidate, setCandidate] = useState({ ...initialCandidate });
  const activeCandidate = candidate;

  useEffect(() => {
    if (isOpen) setActiveTab(initialTab);
  }, [isOpen, candidate?._id, initialTab]);

  // Modal states
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [isAddInterviewModalOpen, setIsAddInterviewModalOpen] = useState(false);
  const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);
  const [isAddOpportunityModalOpen, setIsAddOpportunityModalOpen] =
    useState(false);
  const [isAddRatingModalOpen, setIsAddRatingModalOpen] = useState(false);
  const [isAddContractModalOpen, setIsAddContractModalOpen] = useState(false);
  const [isAddPayslipModalOpen, setIsAddPayslipModalOpen] = useState(false);
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);
  const [isAdvancePaymentModalOpen, setIsAdvancePaymentModalOpen] =
    useState(false);
  const [isReferenceCheckModalOpen, setIsReferenceCheckModalOpen] =
    useState(false);
  // Données liées aux acomptes
      const [isSendToFreelanceModalOpen, setIsSendToFreelanceModalOpen] =
    useState(false);
  const [isSickLeaveModalOpen, setIsSickLeaveModalOpen] = useState(false);
  const [isAddAtdModalOpen, setIsAddAtdModalOpen] = useState(false);
  const [isPlacementContractModalOpen, setIsPlacementContractModalOpen] =
    useState(false);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (event) => {
      if (event.key !== "Escape" || event.defaultPrevented) return;
      const nestedModalOpen = [
        isAddDocumentModalOpen,
        isAddInterviewModalOpen,
        isAddCommentModalOpen,
        isAddOpportunityModalOpen,
        isAddRatingModalOpen,
        isAddContractModalOpen,
        isAddPayslipModalOpen,
        isActivateModalOpen,
        isAdvancePaymentModalOpen,
        isReferenceCheckModalOpen,
        isSendToFreelanceModalOpen,
        isSickLeaveModalOpen,
        isAddAtdModalOpen,
        isPlacementContractModalOpen,
        isEditProfileModalOpen,
        sendCvOpen,
      ].some(Boolean);
      const nestedDialog = Array.from(
        document.querySelectorAll('[role="dialog"]'),
      ).some(
        (dialog) =>
          dialog.getAttribute("aria-labelledby") !==
            "candidate-detail-title" && dialog.getClientRects().length > 0,
      );
      if (nestedModalOpen || nestedDialog) return;
      onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [
    isOpen,
    onClose,
    isAddDocumentModalOpen,
    isAddInterviewModalOpen,
    isAddCommentModalOpen,
    isAddOpportunityModalOpen,
    isAddRatingModalOpen,
    isAddContractModalOpen,
    isAddPayslipModalOpen,
    isActivateModalOpen,
    isAdvancePaymentModalOpen,
    isReferenceCheckModalOpen,
    isSendToFreelanceModalOpen,
    isSickLeaveModalOpen,
    isAddAtdModalOpen,
    isPlacementContractModalOpen,
    isEditProfileModalOpen,
    sendCvOpen,
  ]);


  const [showNet, setShowNet] = useState(false); // Etat pour basculer entre brut et net
  // Fonction pour obtenir l'icône de statut
  const getStatusIcon = (status) => {
    switch (status) {
      case 'Disponible':
        return <CheckCircle2 className="w-4 h-4 text-green-600" />;
      case 'En mission':
        return <Clock className="w-4 h-4 text-orange-500" />;
      case 'Indisponible':
        return <XCircle className="w-4 h-4 text-red-500" />;
      default:
        return <AlertCircle className="w-4 h-4 text-gray-500" />;
    }
  };

  // Fonction pour obtenir la couleur de statut
  const getStatusColor = (status) => {
    switch (status) {
      case 'Disponible':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'En mission':
        return 'text-orange-600 bg-orange-50 border-orange-200';
      case 'Indisponible':
        return 'text-red-600 bg-red-50 border-red-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  // Formatage de l'expérience
  const formatExperience = (years) => {
    if (years === 0) return "Débutant";
    if (years === 1) return "1 an d'expérience";
    return `${years} ans d'expérience`;
  };

  // Formatage des montants avec gestion des erreurs
  const formatAmount = (amount, decimals = 0) => {
    if (!amount || amount === null || amount === undefined) {
      return "Non renseigné";
    }

    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) {
      return "Non renseigné";
    }

    return decimals > 0 ? numAmount.toFixed(decimals) : numAmount.toLocaleString();
  };

  const handleToggleSalary = () => {
    setShowNet(!showNet); // Inverse la valeur de showNet
  };

  // Formatage de la date au format français
  const formatDate = (dateString) => {
    if (!dateString) return "Non renseigné";

    const date = new Date(dateString);

    // Vérifier si la date est valide
    if (isNaN(date.getTime())) {
      return "Date invalide";
    }

    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  
  
  
  
  /*   const setMonthlySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12).toFixed(2))
      setMonthlySal(value)
      setDailySal((parseFloat(value) / 151.67).toFixed(2))
    }
  }

  const setDailySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12 * 151.67).toFixed(2))
      setMonthlySal((parseFloat(value) * 151.67).toFixed(2))
      setDailySal(value)
    }
  } */

  // Définition des onglets
  const tabs = [
    { id: "profile", label: "Informations", icon: User },
    { id: "documents", label: "Documents", icon: FileText },
    { id: "availability", label: "Disponibilités", icon: Clock },
    { id: "interviews", label: "Entretiens", icon: Calendar },
    { id: "opportunities", label: "Candidature", icon: Target },
    { id: "pressentis", label: "Pressentis", icon: Target },
    { id: "contracts", label: "Contrats", icon: Briefcase },
    { id: "absences", label: "Absences", icon: Activity },
    { id: "advances", label: "Acomptes", icon: DollarSign },
    { id: "cvSent", label: "CV envoyés", icon: Mail },
    { id: "history", label: "Historique & notes", icon: Clock },
    { id: "evaluations", label: "Évaluations", icon: MessageSquare },
  ];

  if (!candidate) {
    return null;
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex bg-black bg-opacity-50"
          onClick={onClose}
        >
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-labelledby="candidate-detail-title"
            className="jm-refined candidate-detail-screen flex h-[100dvh] w-screen max-w-none flex-col overflow-hidden bg-white"
            onClick={(e) => e.stopPropagation()}
          >
            <header className="candidate-detail-header border-b border-slate-200 bg-white px-5 py-4 sm:px-8">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div className="flex min-w-0 items-center gap-4"><CandidatePhoto key={candidate._id} candidate={candidate} onUpdated={updated => {setCandidate(updated);setCandidates?.(current => current.map(row => row._id === updated._id ? updated : row));}} /><div className="min-w-0"><div className="flex flex-wrap items-center gap-3"><h2 id="candidate-detail-title" className="text-2xl font-bold text-slate-900">{candidateName(candidate)}<RqthBadge value={candidate.isRQTH} /></h2><span className="inline-block rounded-full bg-blue-50 px-2.5 py-1 text-sm font-semibold text-blue-700">{candidate.pld != null && String(candidate.pld).trim() !== "" ? "Intérimaire" : "Candidat"}</span></div>{(candidate.jobTitle || candidate.pld) && <p className="mt-1 text-sm text-slate-500">{candidate.jobTitle}{candidate.pld ? `${candidate.jobTitle ? " · " : ""}N° ${candidate.pld}` : ""}</p>}<div className="mt-2 flex flex-wrap gap-x-5 gap-y-2 text-base sm:text-lg font-medium text-blue-800">{candidate.phone && <a href={`tel:${candidate.phone}`} className="inline-flex items-center gap-2"><Phone size={18} />{formatPhone(candidate.phone)}</a>}{candidate.email && <a href={`mailto:${candidate.email}`} className="inline-flex min-w-0 items-center gap-2 break-all"><Mail className="shrink-0" size={18} />{candidate.email}</a>}</div></div></div>
                <div className="flex shrink-0 items-center gap-3">
                  <button type="button" onClick={()=>setSendCvOpen(true)} className="candidate-send-cv rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800">Envoyer un CV anonymisé</button>
                <button type="button" aria-label="Fermer la fiche candidat" onClick={onClose} className="rounded-lg p-2 text-slate-500 hover:bg-slate-100"><X size={22} /></button>
                </div>
              </div>
            </header>
            {sendCvOpen && <SendAnonymousCvModal key={candidate._id} candidate={candidate} onClose={()=>setSendCvOpen(false)} onSent={()=>setCvHistoryVersion(v=>v+1)} />}
            {/* Navigation par onglets */}
            <div className="bg-slate-50 border-b border-slate-200">
              <div className="px-3">
                <div className="candidate-detail-tabs">
                  {tabs.map((tab) => {
                    const IconComponent = tab.icon;
                    return (
                      <motion.button
                        key={tab.id}
                        className={`candidate-detail-tab font-medium border-b-2 transition-all duration-200 ${
                          activeTab === tab.id
                            ? "text-blue-600 border-blue-600 bg-white"
                            : "text-slate-600 border-transparent hover:text-slate-900 hover:border-slate-300"
                        }`}
                        onClick={() => setActiveTab(tab.id)}
                        whileHover={{ y: -1 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <IconComponent className="w-4 h-4" />
                        <span>{tab.label}</span>
                      </motion.button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Contenu des onglets */}
            <div className="flex-1 overflow-y-auto">
              <div className="p-4 sm:p-6">


                <AnimatePresence mode="wait">
                  {activeTab === "absences" && <AbsencesPage key={`absences-${candidate._id}`} candidate={candidate} embedded />}
                  {activeTab === "advances" && <AcomptesPage key={`acomptes-${candidate._id}`} candidateId={candidate._id} candidate={candidate} embedded />}
                  {activeTab === "evaluations" && <CandidateEvaluation key={candidate._id} candidate={candidate} onSaved={updated=>{setCandidate(updated);setCandidates?.(current=>current.map(row=>row._id===updated._id?updated:row));}} />}
                  {activeTab === "profile" && <CandidateProfileEditor key={candidate._id} candidate={candidate} onUpdated={updated => {setCandidate(updated);setCandidates?.(current => current.map(row => row._id === updated._id ? updated : row));}} />}

                  {activeTab === "documents" && (
                    <motion.div
                      key="documents"
                    >
                      <DocumentSection candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Disponibilité */}
                  {activeTab === "availability" && (
                    <motion.div
                      key="availability"
                    >
                      <AvailableTable key={candidate._id} candidate={candidate} setCandidates={setCandidates} onUpdated={setCandidate} />
                    </motion.div>
                  )}

                  {activeTab === "pressentis" && <PressentiClients candidateId={candidate._id} />}
                  {activeTab === "cvSent" && <CvDeliveryHistory kind="candidate" id={candidate._id} refresh={cvHistoryVersion} />}
                  {(activeTab === "history" || activeTab === "comments") && <CandidateHistory key={candidate._id} candidate={candidate} candidates={candidates} setCandidates={setCandidates} />}

                  {/* Onglet Contrats */}
                  {activeTab === "contracts" && (
                    <motion.div
                      key="contracts"
                    >
                      <CandidatContract candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Entretiens */}
                  {activeTab === "interviews" && (
                    <motion.div
                      key="interviews"
                    >
                      <InterviewsSection candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Opportunités */}
                  {activeTab === "opportunities" && (
                    <motion.div
                      key="opportunities"
                    >
                      <OpportunitiesSection candidateId={candidate._id} />
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>

            {/* Modals */}
            <AddDocumentModal
              isOpen={isAddDocumentModalOpen}
              onClose={() => setIsAddDocumentModalOpen(false)}
              onSubmit={(data) => {
                console.log("Document ajouté:", data);
                setIsAddDocumentModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddInterviewModal
              isOpen={isAddInterviewModalOpen}
              onClose={() => setIsAddInterviewModalOpen(false)}
              onSubmit={(data) => {
                console.log("Entretien ajouté:", data);
                setIsAddInterviewModalOpen(false);
              }}
              candidate={candidate}
            />

            <AddCommentModal
              isOpen={isAddCommentModalOpen}
              onClose={() => setIsAddCommentModalOpen(false)}
              onSubmit={(data) => {
                console.log("Commentaire ajouté:", data);
                setIsAddCommentModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddOpportunityModal
              isOpen={isAddOpportunityModalOpen}
              onClose={() => setIsAddOpportunityModalOpen(false)}
              onSubmit={(data) => {
                console.log("Opportunité ajoutée:", data);
                setIsAddOpportunityModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddContractModal
              isOpen={isAddContractModalOpen}
              onClose={() => setIsAddContractModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrat ajouté:", data);
                setIsAddContractModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AddPayslipModal
              isOpen={isAddPayslipModalOpen}
              onClose={() => setIsAddPayslipModalOpen(false)}
              onSubmit={(data) => {
                console.log("Fiche de paie ajoutée:", data);
                setIsAddPayslipModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <ActivateCandidateModal
              isOpen={isActivateModalOpen}
              onClose={() => setIsActivateModalOpen(false)}
              onSubmit={(data) => {
                console.log("Candidat activé:", data);
                setIsActivateModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AdvancePaymentModal hidePaymentMethod isOpen={isAdvancePaymentModalOpen} onClose={() => setIsAdvancePaymentModalOpen(false)} candidateId={candidate._id} onSave={async data => {
              if (!Number.isFinite(Number(data.amount)) || Number(data.amount) <= 0) {message.error("Indiquez un montant positif.");return;}
              try {
                await createAcompte({candidateId: candidate._id, amount: data.amount, paymentDate: data.paymentDate, reason: data.reason});
                setIsAdvancePaymentModalOpen(false);setActiveTab("advances");message.success("Demande transmise à l’agence.");
              } catch (error) {message.error(error.response?.data?.message || "Impossible d’enregistrer la demande.");}
            }} />

            <ReferenceCheckModal
              isOpen={isReferenceCheckModalOpen}
              onClose={() => setIsReferenceCheckModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrôle de référence:", data);
                setIsReferenceCheckModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <SendToFreelanceModal
              isOpen={isSendToFreelanceModalOpen}
              onClose={() => setIsSendToFreelanceModalOpen(false)}
              onSubmit={(data) => {
                console.log("Envoyé à freelance:", data);
                setIsSendToFreelanceModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <SickLeaveModal
              isOpen={isSickLeaveModalOpen}
              onClose={() => setIsSickLeaveModalOpen(false)}
              onSubmit={(data) => {
                console.log("Arrêt maladie ajouté:", data);
                setIsSickLeaveModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AddAtdModal
              isOpen={isAddAtdModalOpen}
              onClose={() => setIsAddAtdModalOpen(false)}
              onSubmit={(data) => {
                console.log("ATD ajouté:", data);
                setIsAddAtdModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <PlacementContractModal
              isOpen={isPlacementContractModalOpen}
              onClose={() => setIsPlacementContractModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrat de placement:", data);
                setIsPlacementContractModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <EditProfileModal
              isOpen={isEditProfileModalOpen}
              onClose={() => setIsEditProfileModalOpen(false)}
              onSubmit={(data) => {
                console.log("Profil modifié:", data);
                setIsEditProfileModalOpen(false);
              }}
              candidate={candidate}
            />

            <AddRatingModal
              isOpen={isAddRatingModalOpen}
              onClose={() => setIsAddRatingModalOpen(false)}
              onSubmit={(data) => {
                console.log("Notation ajoutée:", data);
                setIsAddRatingModalOpen(false);
              }}
              candidateId={candidate.id}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};



 
